import React from 'react';
import { changeLanguage } from 'depop/state/locale';
import { connect } from 'react-redux';

import { style, hover, merge } from 'glamor';

function mapStateToProps({locale}) {
  return {
    language: locale.language,
    availableLanguages: locale.availableLanguages,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onChange: event => dispatch(changeLanguage(event.target.value)),
  };
}

type Props = {
  language: Object,
  availableLanguages: Object,
  onChange: () => void,
};

/**
* A component used in development to switch locales, and
* should never be visible in a production build, right?
*/
function LocaleSwitcher({language, availableLanguages, onChange}: Props) {
  const buttonStyle = style({
    position: 'relative',
    color: '#666',
    display: 'inlineBlock',
    margin: '0 5px',
    border: 0,
    padding: 0,
    fontWeight: 'normal',
    touchAction: 'manipulation',
    cursor: 'pointer',
    userSelect: 'none',
    background: 'none',
    outline: 'none',
    fontSize: 14,
  });

  const hoverStyle = hover({textDecoration: 'underline', color: '#000'});

  const selectedButtonStyle = style({
    color: '#000',
    fontWeight: 'bold',
    textDecoration: 'underline',
  });

  return (
    <div {...style({display: 'inlineBlock'})}>
      ({availableLanguages.map(lang => {
        const styles = [
          buttonStyle,
          hoverStyle,
          ...language === lang.value ? [selectedButtonStyle] : [],
        ];

        return (
          <button key={lang.value} value={lang.value} onClick={onChange} {...merge(styles)}>
            {lang.name}
          </button>
        );
      })})
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LocaleSwitcher);



// WEBPACK FOOTER //
// ../src/client/components/layout/LocaleSwitcher.js